import React, { Component } from 'react';

import './QualidadeVida.scss';

import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import Fade from 'react-reveal/Fade';
import Parallax from 'parallax-js';

import {
	TimelineMax,
	TweenMax
} from 'gsap';

import renderHTML from 'react-render-html';
import Swipeable from 'react-swipeable';
import OwlCarousel from 'react-owl-carousel2';
import '../../../node_modules/react-owl-carousel2/src/owl.carousel.css';
import '../../../node_modules/react-owl-carousel2/lib/styles.css';

import {
    Dispatcher,
    Actions,
    Events
} from '../../flux';

import {
	images,
	views
} from '../../settings';

import {
	Person,
	HoveredImage,
	Compromisso
} from '../../components/';

class QualidadeVida extends Component {

	constructor() {
		super();

        this.images = images;

        this.state = {
            width: window.innerWidth
        };

	    this.scrollTop = this.scrollTop.bind(this);
	    this.globalTransition = this.globalTransition.bind(this);
	}

	scrollTop() {
		this.refs.contentText.scrollTop = 0;
	}

    globalTransition() {
    	Actions.globalTransition();
    }

	componentWillMount() {
    	Actions.menuIntern();
    	Actions.logoIntern();
    	Actions.showFooter();
		Actions.emitPage('5.3 Qualidade de vida');
    }

    componentWillUnmount() {
	}

    componentDidMount() {
    }

	render() {
        const { width } = this.state;
        const isMobile = width <= 769;

		var classItem = [
			'view',
			'qualidade-vida'
		];

        return (

			<div className="views" id="scene">
			
				<Helmet>
	                <title>5.3 Qualidade de vida - Relatório Anual 2018 | ANBIMA</title>
	            </Helmet>

				<div className="views_container">

		        	<article className={ classItem.join(' ') }>

		        		<header className="views__header">
		        			<div className="container">
				        		<h1><span>5.3</span> Qualidade de vida</h1>
		        			</div>
		        		</header>

		        		<header className="views__breadcrumb">
		        			<div className="container">
				        		<p>Home / Pessoas</p>
		        			</div>
		        		</header>

		        		<div className="views__content first_view row">
			        		<div className="container">
			        			
				        		<div className="column column--half column--padding-right">
				        			<Fade bottom>
										<p className="gri_p">
					        				<span className="gri_label"><text>GRI 103-1, 103-2, 103-3</text></span>
										</p>
					        			<h3>Home office</h3>
					        			<p className="first_paragraph">
						        			Começou em novembro um programa piloto de home office, com <b class="green_text">60 funcionários</b>, que puderam acertar com seus gestores um dia da semana para trabalhar de casa. Após dois meses, foi realizada pesquisa que mostrou o sucesso da iniciativa.
					        				<br /><br />
											O feedback foi positivo tanto para colaboradores, que demonstraram contentamento, quanto para gestores – 100% deles afirmaram em pesquisa que a produtividade dos funcionários aumentou, com redução significativa no tempo de execução de algumas tarefas. Em 2019, o benefício deve ser estendido para todos, buscando aumentar a qualidade de vida dos funcionários e otimizar as atividades.
											<br />
										</p>
				        			</Fade>
				        		</div>

				        		<div className="column column--half column--image-full column--image-full-center">
				        			<Fade bottom>
					        			<HoveredImage
					        				image1={ this.images.qualidade_vida_img1 }
					        				image2={ this.images.qualidade_vida_img1_hover } /> 
				        			</Fade>
				        		</div>

			        		</div> 
		        		</div>


		        		<div className="views__content views__content--section row qualidade__view qualidade__view--topics view__gray">
			        		<div className="container">
				        		<div className="column column--half column--padding-right">
				        			<Fade bottom>
				        				<h3>Horário flexível</h3>
					        			<p>Criada em março, a jornada flexível agradou os colaboradores, que passaram a administrar melhor suas agendas. Cumprindo as mesmas oito horas diárias com uma hora de almoço, eles puderam optar por trabalhar das 8h às 17h; das 9h às 18h; ou das 10h às 19h.</p>
				        			</Fade>
				        		</div>

				        		<div className="column column--half column--padding-left">
				        			<Fade bottom>
				        				<h3>Programa “De bem com a vida”</h3>
					        			<p>Mais de 150 pessoas participaram da campanha lançada em agosto com o objetivo de diminuir os fatores de risco dos colaboradores por meio de hábitos saudáveis. O projeto começou com exames clínicos e seguiu com desafios para equipes, que incluíam prática de exercícios e alimentação saudável.</p>
				        			</Fade>
				        		</div>
			        		</div>
		        		</div>


		        		<div className="views__content views__content--section row last__view view__gray">
			        		<div className="container">
				        		<div className="column column--image-full column--image-full-center">
				        			<Fade bottom>
				        				<img src={ this.images.qualidade_vida_img2 } />
				        			</Fade>
				        		</div>
			        		</div>
		        		</div>

		        	</article>

        		</div>
    		</div>
    	);
	}
}

export { QualidadeVida };
